import Vue from 'vue';
import Vuex from 'vuex';
import api, { setAuthToken, clearAuthToken } from '../services/api';

Vue.use(Vuex);

const saved = localStorage.getItem('zg_token');

export default new Vuex.Store({
  state: {
    token: saved || null,
    me: null,
    games: []
  },
  getters: {
    isAuth: state => !!state.token,
    me: s => s.me,
    games: s => s.games
  },
  mutations: {
    SET_TOKEN(state, t) { state.token = t; },
    SET_ME(state, me) { state.me = me; },
    SET_GAMES(state, games) { state.games = games; }
  },
  actions: {
    async login({ commit, dispatch }, { usernameOrEmail, password }) {
      const { data } = await api.post('/api/login', { usernameOrEmail, password });
      commit('SET_TOKEN', data.token);
      localStorage.setItem('zg_token', data.token);
      setAuthToken(data.token);
      await dispatch('fetchMe');
    },
    async register({ commit, dispatch }, { username, email, password, displayName }) {
      const { data } = await api.post('/api/register', { username, email, password, displayName });
      commit('SET_TOKEN', data.token);
      localStorage.setItem('zg_token', data.token);
      setAuthToken(data.token);
      await dispatch('fetchMe');
    },
    logout({ commit }) {
      commit('SET_TOKEN', null);
      commit('SET_ME', null);
      localStorage.removeItem('zg_token');
      clearAuthToken();
    },
    async fetchMe({ commit, state }) {
      if (!state.token) return;
      setAuthToken(state.token);
      const { data } = await api.get('/api/me');
      commit('SET_ME', data);
    },
    async listGames({ commit }) {
      const { data } = await api.get('/api/games');
      commit('SET_GAMES', data);
    },
    async saveMyGames({ dispatch }, gameCodes) {
      await api.post('/api/me/games', { gameCodes });
      await dispatch('fetchMe');
    }
  }
});
